// frontend/src/slices/playlistsApiSlice.js - VERSION CORRIGÉE
import { apiSlice } from './apiSlice';
const PLAYLISTS_URL = '/api/playlists';

export const playlistsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Récupérer les playlists par produit
    getPlaylistsByProduct: builder.query({
      query: (productId) => ({
        url: `${PLAYLISTS_URL}/product/${productId}`,
      }),
      providesTags: ['Playlist'],
    }),
    
    // ✅ Récupérer une playlist spécifique pour client
    getPlaylistForClient: builder.query({
      query: (playlistId) => ({
        url: `${PLAYLISTS_URL}/client/${playlistId}`,
      }),
      providesTags: ['Playlist'],
      keepUnusedDataFor: 5,
    }),
    
    // ✅ Récupérer les playlists du formateur connecté
    getFormateurPlaylists: builder.query({
      query: () => ({
        url: `${PLAYLISTS_URL}/formateur/my-playlists`,
      }),
      providesTags: ['Playlists'],
      keepUnusedDataFor: 5,
    }),
    
    // ✅ Créer une playlist
    createPlaylist: builder.mutation({
      query: (playlistData) => ({
        url: PLAYLISTS_URL,
        method: 'POST',
        body: playlistData,
      }),
      invalidatesTags: ['Playlists'],
    }),
    
    // ✅ CORRECTION CRITIQUE : Mettre à jour une playlist (route formateur)
    updatePlaylist: builder.mutation({
      query: ({ playlistId, formData }) => ({
        url: `${PLAYLISTS_URL}/formateur/${playlistId}`,  // ✅ Route spécifique formateur
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['Playlists'],
    }),
    
    // ✅ Vérifier l'accès à une playlist
    checkPlaylistAccess: builder.query({
      query: (playlistId) => ({
        url: `${PLAYLISTS_URL}/client/${playlistId}`,
      }),
      providesTags: ['PlaylistAccess'],
    }),

    // ✅ Récupérer les vidéos d'une playlist (formateur)
    getFormateurPlaylistVideos: builder.query({
      query: (playlistId) => ({
        url: `${PLAYLISTS_URL}/formateur/${playlistId}/videos`,
      }),
      providesTags: ['PlaylistVideos'],
    }),

    // ✅ Ajouter une vidéo à une playlist (formateur)
    addVideoToPlaylist: builder.mutation({
      query: ({ playlistId, formData }) => ({
        url: `${PLAYLISTS_URL}/formateur/${playlistId}/videos`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['PlaylistVideos', 'Playlists'],
    }),

    // ✅ Supprimer une vidéo d'une playlist (formateur)
    deleteVideoFromPlaylist: builder.mutation({
      query: ({ playlistId, videoId }) => ({
        url: `${PLAYLISTS_URL}/formateur/${playlistId}/videos/${videoId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PlaylistVideos', 'Playlists'],
    }),
  }),
});

export const { 
  useGetPlaylistsByProductQuery,
  useGetPlaylistForClientQuery,
  useGetFormateurPlaylistsQuery,
  useCreatePlaylistMutation,
  useUpdatePlaylistMutation,
  useCheckPlaylistAccessQuery,
  useGetFormateurPlaylistVideosQuery,
  useAddVideoToPlaylistMutation,
  useDeleteVideoFromPlaylistMutation,
} = playlistsApiSlice;